"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const ForwardRefHOC_1 = __importDefault(require("../ForwardRefHOC"));
const Typography_1 = __importDefault(require("../Typography"));
const Switch = (props) => {
    const { forwardedRef, id, className, label, suffixLabel, reverseOrder, checkedColor, disabled, uncheckedColor, onChange } = props, restProps = __rest(props, ["forwardedRef", "id", "className", "label", "suffixLabel", "reverseOrder", "checkedColor", "disabled", "uncheckedColor", "onChange"]);
    const [trackColor, changeTrackColor] = react_1.useState(props.defaultChecked ? checkedColor : uncheckedColor);
    function handleOnChange(e) {
        changeTrackColor(e.target.checked ? checkedColor : uncheckedColor);
        if (onChange) {
            onChange(e);
        }
    }
    const finalClassName = classnames_1.default('switch-wrapper', { 'switch-wrapper--reverse-order': reverseOrder }, className);
    const labelClassName = classnames_1.default('switch-wrapper__label', {
        'sr-only': !label && !suffixLabel
    }, { 'is-disabled': disabled });
    const labelSuffixClassName = classnames_1.default('switch-wrapper__label switch-wrapper__label--suffix', { 'is-disabled': disabled });
    const inputClassName = classnames_1.default('switch-wrapper__input', {
        [`bg-${trackColor}`]: trackColor
    }, {
        'switch-wrapper__input--bg-default': !trackColor
    });
    return (react_1.default.createElement("div", { className: finalClassName },
        react_1.default.createElement("label", { className: labelClassName, htmlFor: id }, label || suffixLabel || id),
        react_1.default.createElement("input", Object.assign({ id: id, ref: forwardedRef, className: inputClassName, type: 'checkbox', role: 'switch', "aria-checked": props.checked, "aria-errormessage": props['aria-errormessage'], "aria-invalid": props.error || null, onChange: handleOnChange, disabled: disabled }, restProps)),
        label && suffixLabel ? (react_1.default.createElement(Typography_1.default, { className: labelSuffixClassName, as: 'span', type: 'label-sm' }, suffixLabel)) : null));
};
exports.Switch = Switch;
exports.Switch.displayName = 'Switch';
exports.default = ForwardRefHOC_1.default(exports.Switch);
